import React from 'react';
import { COLLECTION_MOCKUP } from '../data/collection';
interface CollectionMockupProps {
  priority?: boolean;
  /** Width limits; defaults to a 600px cap. Always capped at the available width. */
  className?: string;
}

/** The complete collection mockup, shown whole at its natural proportion. */
export function CollectionMockup({
  priority = false,
  className = 'max-w-[600px]'
}: CollectionMockupProps) {
  const {
    src,
    alt,
    width,
    height
  } = COLLECTION_MOCKUP;
  const priorityProps = priority ? {
    fetchpriority: 'high'
  } as Record<string, string> : {};
  return <div className={`mx-auto w-full min-w-0 ${className}`} data-id="element-55" data-mp="2jcffq9w296rs">
      <img src={src} alt={alt} width={width} height={height} loading={priority ? 'eager' : 'lazy'} decoding={priority ? 'sync' : 'async'} {...priorityProps} className="block h-auto w-full max-w-full object-contain" style={{
      aspectRatio: `${width} / ${height}`
    }} data-id="element-56" data-mp="2je09vyegqnp4" />
    </div>;
}